//import api from '../api';
import { newAPIPost } from '../api/index.js';

export default {
  state: {
    schedules: [],
    searchRequest: {},
  },
  mutations: {
    updateSchedules(state, schedules) {
      state.schedules = schedules;
    },
    updateScheduleSearchRequest(state, searchRequest) {
      state.searchRequest = searchRequest;
    },
  },
  actions: {
    async loadSchedules({ commit, state, getters }, request) {
      const fallbackRequest = request || state.searchRequest;
      const requestToSend = JSON.parse(JSON.stringify(fallbackRequest));
      if (requestToSend.weekStart && !requestToSend.weekEnd) {
        requestToSend.weekEnd = requestToSend.weekStart;
      }
      if (requestToSend.yearStart && !requestToSend.yearEnd) {
        requestToSend.yearEnd = requestToSend.yearStart;
      }
      if (requestToSend.etaPlanStart && !requestToSend.etaPlanEnd) {
        requestToSend.etaPlanEnd = moment(requestToSend.etaPlanStart).endOf('d').toDate();
      }
      if (requestToSend.etaAssignedStart && !requestToSend.etaAssignedEnd) {
        requestToSend.etaAssignedEnd = moment(requestToSend.etaAssignedStart).endOf('d').toDate();
      }
      if (requestToSend.callDateStart && !requestToSend.callDateEnd) {
        requestToSend.callDateEnd = moment(requestToSend.callDateStart).endOf('d').toDate();
      }

      requestToSend.driverGroups = getters.flatWithChildDriverGroups(requestToSend.driverGroups);

      //const result = await api.post('/api/w/schedules', requestToSend);
      const result = await newAPIPost('/api/w/schedules', requestToSend);
      commit('updateScheduleSearchRequest', fallbackRequest);
      return commit('updateSchedules', result);
    },
    saveSchedules({ dispatch }, request) {
      //return api.post('/api/w/schedules/save', request);
      return newAPIPost('/api/w/schedules/save', request);
    },
    assignLoadIds({ dispatch }, request) {
      //return api.post('/api/w/schedules/assignLoad', request);
      return newAPIPost('/api/w/schedules/assignLoad', request);
    },
    unAssignLoadId({ dispatch }, request) {
      //return api.post('/api/w/schedules/unAssignLoad', request);
      return newAPIPost('/api/w/schedules/unAssignLoad', request);
    },
  },
  getters: {
    getSchedules: state => _(state.schedules).sortBy(it => `${(it.store || {}).id}_${it.etaPlan}_${it.pickupCounter}`),
  },
};
